import {CommonMessages} from '../common.messages';

export const PanelSettingsGroupsAddMessages = {
    RegisterGroupFailed: {
        key: 'RegisterGroupFailed',
        message: 'Error while processing registration group request. Unable to register group.'
    },
    RegisterGroupSucceed: {
        key: 'RegisterGroupSucceed',
        message: 'The group is successfully created.'
    },
    ClientTypeSelectionIsRequired: {
        key: 'ClientTypeSelectionIsRequired',
        message: 'Client type must be selected first.'
    },
    ClientAliasUndefined: {
        key: 'ClientAliasUndefined',
        message: 'No alias set for this client.'
    },
    InvalidPlanConfiguration: {
        key: 'InvalidPlanConfiguration',
        message: 'Either Trading Plan or Plan Type can be selected.'
    },
    ...CommonMessages
};
